import React from "react";
import { AuthenticationForm } from "@components/ui";

import { ComposeURLWithGetQueryArguments } from "@shared/utils";
import { PagePaths } from "@shared/constants";
import { useTranslation } from "react-i18next";
import { useDocumentTitle } from "@shared/hooks/useDocumentTitle";
import { t_congratulations } from "@i18n/usualTexts/t_congratulations";
import { ActionButton } from "@components/ui";
import { useIsMobileButtons } from "@shared/hooks/useIsMobileButtons";

const CongratulationsPage: React.FC = () => {
  const { t } = useTranslation();
  useDocumentTitle(t("signup.congratulations.pageTitle"));
  const isMobileButtons = useIsMobileButtons();

  const toLoginPage = () => {
    window.location.href = ComposeURLWithGetQueryArguments(PagePaths.LOGIN.IDENTITY);
  };

  const loginButton = (
    <ActionButton variant="primary" onClick={toLoginPage} className={isMobileButtons ? "h-11 w-full" : "w-full"}>
      {t(t_congratulations.loginLink)}
    </ActionButton>
  );

  const mobileFooter = isMobileButtons ? (
    <div className="w-full">{loginButton}</div>
  ) : undefined;

  return (
    <AuthenticationForm
      title={t(t_congratulations.title)}
      subtitle={t(t_congratulations.subtitle)}
      mobileFooter={mobileFooter}
      hideClientHeader
      centerContent
    >
      <div className="flex flex-col items-center gap-4 py-4">
        <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ background: 'var(--surface-hover)' }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: 'var(--accent-primary)' }}>
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>
        <p className="text-sm text-center leading-relaxed font-medium" style={{ color: 'var(--text-primary)' }}>
          {t(t_congratulations.bodyText)}
        </p>
      </div>

      {!isMobileButtons && (
        <div className="mt-2">
          {loginButton}
        </div>
      )}
    </AuthenticationForm>
  );
};

export default CongratulationsPage;